import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getStatusDescriptionFromStatusValue, getCountryNameByCountryCode, getOrderTypeText } from '../../../../../utils/utility';

export default function directCustomerOrderListColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    config.data.forEach((order, index) => {
        let row = [];
        const rowId = order.orderId;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;

            let columnValue = null;
            let linkDestination = null;
            let isDisabled = false;

            if (columnDataType === "link") {
                if (columnId === "orderId" && order.orderId) {
                    columnValue = order.orderId;
                    linkDestination = '/my-customer-orders/order-detail/' + order.orderId;
                }
            }
            else if (columnDataType === "string") {
                if (columnId === "vendorOrderId") {
                    columnValue = order.vendorOrderId || "";
                }
                if (columnId === "creationDate") {
                    columnValue = getDateWithSpecificFormat(order.createdDate);
                }
                if (columnId === "orderType") {
                    columnValue = getOrderTypeText(order.orderType) || "";
                }
                if (columnId === "countryName") {
                    columnValue = order.countryCode ? getCountryNameByCountryCode(order.countryCode) : "";
                }
                if (columnId === "company") {
                    columnValue = order.company || "";
                }
                if (columnId === "legalEntityName") {
                    columnValue = order.legalEntity || "";
                }
                else if (columnId === "collectionCity") {
                    columnValue = order.collectionCity || "";
                }
                else if (columnId === "totalAssets") {
                    columnValue = (order.qtyOfAssetsRequested && order.qtyOfAssetsRequested) || "";
                }
                else if (columnId === "quotedNetValue") {
                    columnValue = order.quotedNetValue !== null ? order.quotedNetValue?.toFixed(2) : "";
                }
                else if (columnId === "finalNetValue") {
                    columnValue = order.finalNetValue !== null ? order.finalNetValue?.toFixed(2) : "";
                }
                else if (columnId === "finalHWBuybackValue") {
                    columnValue = order.finalHWBuybackValue !== null ? order.finalHWBuybackValue?.toFixed(2) : "";
                }
                else if (columnId === "finalServiceCost") {
                    columnValue = order.finalServiceCosts !== null ? order.finalServiceCosts?.toFixed(2) : "";
                }
                else if (columnId === "reportingStatus") {
                    columnValue = order.reportingStatus ? (order.reportingStatus !== "NOT_AVAILABLE" ? getStatusDescriptionFromStatusValue(order.reportingStatus) : "") : "";
                }
                else if (columnId === "paymentStatus") {
                    columnValue = columnValue = order.paymentStatus ? (order.paymentStatus !== "NOT_AVAILABLE" ? getStatusDescriptionFromStatusValue(order.paymentStatus) : "") : "";
                }
                else if (column.id === "currencyCode") {
                    columnValue = order.currencyCode || "";
                }
                else if (columnId === "collectionDate") {
                    columnValue = getDateWithSpecificFormat(order.collectionDate) || "";
                    if(order.orderType === '2') {
                        isDisabled = true;
                    }
                }
                else if (columnId === "assetsReceiptDate") {
                    columnValue = getDateWithSpecificFormat(order.assetsReceiptDate) || "";
                }                
                else if (columnId === "expectedReportDate") {
                    columnValue = getDateWithSpecificFormat(order.expectedReportDate) || "";
                }                
                else if (column.id === "owner") {
                    columnValue = order.owner || "";
                }
                else if (columnId === "status") {
                    let statusForCustomer;
                    if (order.status === 'ORDER_SENT' || order.status === 'ORDER_RECEIVED') {
                        statusForCustomer = 'ORDER_SUBMITTED';
                    }
                    columnValue = getStatusDescriptionFromStatusValue(statusForCustomer || order.status) || "";
                }
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    disabled: isDisabled,
                    linkDestination: linkDestination,
                    clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
